import { parseItems } from './parsers/items';
import { toError } from './parsers/error';
export function initItems(settings, http) {
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      page: options.paging.cursor || null
    };
    return http.get(`${settings.apiUrl}${settings.apiPath}/videos`, requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(parseItems).catch(toError);
  }
  return {
    list
  };
}